import {
  call,
} from 'redux-saga/effects';
import { getAEMHeadlessPropsRequest } from './aemHeadlessProps';

export function* getOrderTrackerRequest(): Generator {
  yield call(getAEMHeadlessPropsRequest);
}
